<template>
  <div>
    <h3>Your request to reset your password has been sent</h3>
    <p>Please check your email inbox and follow the steps described in the "reset password" email.</p>
    <div class="ly-row mt-2">
      <router-link to="/login"> <lp-button type="button" id="fgt-back-to-login"> Go Back</lp-button></router-link>
    </div>
  </div>
</template>

<style>
.reset-password-form {
  margin: 0px 0px;
  padding: 0px 0px;
}
</style>
